import React, { useState, useEffect, Fragment } from 'react';
import PropTypes from 'prop-types';
import ToggleItemDetails from './ToggleItemDetails';
import { MaterialUiCore, MaterialUiIcons } from '@gscope-mfe/common-libs';
const { makeStyles } = MaterialUiCore,
    { Typography } = MaterialUiCore,
    InfoOutlinedIcon = MaterialUiIcons.InfoOutlined;
const useStyles = makeStyles((theme) => ({
    itemsContainer: {
        width: '100%',
        padding: '1rem 1rem 0.4rem',
    },
    itemsSubContainer: {
        paddingTop: '0.4rem',
        backgroundColor: '#f7f7f7',
        display: 'flex',
        width: '100%',
    },
    itemTitleContainer: {
        width: '100%',
        border: (props) => (props.titleContainerBorder ? props.titleContainerBorder : '1px solid #0071dc'),
        margin: '0 1rem',
        paddingLeft: '0.5rem',
        backgroundColor: (props) => (props.titleContainerBgColor ? props.titleContainerBgColor : '#f7f7f7'),
        textAlign: 'left',
        display: 'flex',
        alignItems: 'center',
    },
    itemTitle: {
        padding: '0.8rem 1rem',
    },
}));

const prepareListItems = (itemPayload, selectedItem) => {
    return itemPayload.map((element, index) => {
        if (index === selectedItem) {
            return {
                itemId: index,
                isItemSelected: true,
                ...element,
            };
        }

        return {
            itemId: index,
            isItemSelected: false,
            ...element,
        };
    });
};

const ToggleItem = (props) => {
    const { items, defaultSelection, onSelectBgColor, titleInfoIcon } = props;
    const classes = useStyles(props);
    const [currentSelection, setCurrentSelection] = useState(+defaultSelection - 1);
    const [listItems, setListItems] = useState(prepareListItems(items, currentSelection));
    useEffect(() => {
        setListItems(prepareListItems(items, currentSelection));
    }, [items, currentSelection]);

    const handleOnSelectItem = (itemId) => {
        setCurrentSelection(+itemId);
        setListItems(
            listItems.map((item) => {
                if (item.itemId === itemId) {
                    item.isItemSelected = true;
                } else {
                    item.isItemSelected = false;
                }

                return item;
            }),
        );
    };

    const renderItems = (items) =>
        items.map((item) => (
            <ToggleItemDetails
                key={item.itemId}
                params={item}
                onSelectItem={handleOnSelectItem}
                onSelectBgColor={onSelectBgColor}
            />
        ));

    const itemTitle = listItems[currentSelection].title;
    return (
        <Fragment>
            <Typography component="div" className={classes.itemsContainer}>
                <Typography component="div" className={classes.itemsSubContainer}>
                    {renderItems(listItems)}
                </Typography>
            </Typography>
            {itemTitle && (
                <Typography component="div" className={classes.itemTitleContainer}>
                    {titleInfoIcon ? titleInfoIcon : <InfoOutlinedIcon />}
                    <Typography component="div" className={classes.itemTitle}>
                        {itemTitle}
                    </Typography>
                </Typography>
            )}
        </Fragment>
    );
};

ToggleItem.propTypes = {
    items: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string.isRequired,
            value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
            icon: PropTypes.object.isRequired,
            title: PropTypes.object,
            customStyle: PropTypes.object,
        }),
    ).isRequired,
    defaultSelection: PropTypes.number,
    onSelectBgColor: PropTypes.string,
    titleInfoIcon: PropTypes.object,
    titleContainerBorder: PropTypes.string,
    titleContainerBgColor: PropTypes.string,
};
ToggleItem.defaultProps = {
    defaultSelection: 1,
    onSelectBgColor: '#d0419b',
    titleInfoIcon: <InfoOutlinedIcon />,
    titleContainerBorder: '1px solid #0071dc',
    titleContainerBgColor: '#f7f7f7',
};
export default ToggleItem;
